export default function getLocale() {
  let cookie = {};
  document.cookie.split(";").forEach(function (el) {
    let [key, value] = el.split("=");
    cookie[key.trim()] = value;
  });
  const locale = cookie["user_local"];
  return locale === undefined || locale === "en" ? "" : `/${locale}`;
}
